import React, { useState } from "react";

import createDecorator from "final-form-focus";
import { Form } from "react-final-form";
import { useSelector } from "react-redux";

import { applyCostsToForm, calculateTotals } from "../QuoteEmployeePriceBreakdown/QuoteEmployeePriceBreakdownBody";
import { formatEmployeeProfileAsInitialValues } from "Common/EnterAges/Components/Helpers/FormHelpers";

import CartEmployeePriceBreakdownForm from "./CartEmployeePriceBreakdownForm";
import CartEmployeePriceBreakdownTable from "./CartEmployeePriceBreakdownTable";

const focusOnErrors = createDecorator();

export const CartEmployeePriceBreakdownBody = ({ plan: medicalPlan }) => {
  const employeeProfiles = useSelector((state) => state.employeeProfile);

  const [contributionType, setContributionType] = useState("percentage");
  const [employeeContribution, setEmployeeContribution] = useState(50);
  const [dependentContribution, setDependentContribution] = useState(0);

  let contributions = {};

  if (contributionType == "percentage") {
    contributions = {
      percentage: {
        employee: employeeContribution,
        dependent: dependentContribution,
      },
    };
  } else {
    contributions = {
      fixed: {
        employee: employeeContribution,
        dependent: dependentContribution,
      },
    };
  }

  const employeeCosts = (medicalPlan && medicalPlan.employee_costs) || [];
  const formEmployeeProfiles = applyCostsToForm({
    formEmployeeProfiles: formatEmployeeProfileAsInitialValues(employeeProfiles),
    employeeCosts,
    contributions,
    pricingType: medicalPlan.pricing_type,
  });

  const initialValues = {
    employee_contribution: employeeContribution,
    dependent_contribution: dependentContribution,
  };

  const totals = calculateTotals(formEmployeeProfiles);
  return (
    <>
      <Form onSubmit={() => {}} decorators={[focusOnErrors]} initialValues={initialValues}>
        {(props) => (
          <CartEmployeePriceBreakdownForm
            {...props}
            medicalPlan={medicalPlan}
            totals={totals}
            contributionType={contributionType}
            setContributions={{
              setContributionType,
              setEmployeeContribution,
              setDependentContribution,
            }}
          />
        )}
      </Form>
      <CartEmployeePriceBreakdownTable employees={formEmployeeProfiles} totals={totals} />
    </>
  );
};

export default CartEmployeePriceBreakdownBody;
